import { WindowRef } from '@one/app/shared/classes/window-ref';
import { windowFactory } from '@one/app/shared/factories/window.factory';
import { WINDOW } from '@one/app/shared/tokens/window.token';
import { FactoryProvider, PLATFORM_ID } from '@angular/core';

export const WINDOW_PROVIDER: FactoryProvider = {
  deps: [WindowRef, PLATFORM_ID],
  provide: WINDOW,
  useFactory: windowFactory,
};
